import { jsx as _jsx } from "react/jsx-runtime";
/* Generated file. Do not modify. */
import { createElement } from 'react';
import { IconSvg } from '../../icons/IconSvg.js';
export const HashtagIcon = (props) => createElement(IconSvg, {
    ...props,
    viewBox: "0 0 24 24"
}, _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.52059 7.5L10.0083 1.94788L11.4572 2.3361L10.0735 7.5H16.338L17.7192 2.3454L19.1681 2.73363L17.891 7.5H23V9H17.489L15.8813 15H21V16.5H15.4794L13.9917 22.0521L12.5428 21.6639L13.9265 16.5H7.66196L6.28078 21.6546L4.83189 21.2664L6.10904 16.5H1V15H6.51097L8.11866 9H3V7.5H8.52059ZM9.67158 9L8.06388 15H14.3284L15.9361 9H9.67158Z", fill: "currentColor" }));
//# sourceMappingURL=HashtagIcon.js.map